/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestFiltersCto } from '../../models/test-filters-cto';

export interface GetTestFilters$Json$Params {
}

export function getTestFilters$Json(http: HttpClient, rootUrl: string, params?: GetTestFilters$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TestFiltersCto>> {
  const rb = new RequestBuilder(rootUrl, getTestFilters$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestFiltersCto>;
    })
  );
}

getTestFilters$Json.PATH = '/automatedtest/v1/cicd/filters';
